import loadable from '@loadable/component';

export const sponsor_public = loadable(() => import("./SponsorPublicPage"));